import React, { useState, useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { ReportResultType } from 'types';
import { AsyncResultStateType } from './types';

const defaultState: AsyncResultStateType = {
  reportResults: [],
  addReportResult: () => {},
};

const AsyncResultContext = React.createContext<AsyncResultStateType>(defaultState);

interface AsyncResultProviderProps {
  children: React.ReactNode;
}

export const AsyncResultProvider = ({ children }: AsyncResultProviderProps) => {
  const [reportResults, setReportResults] = useState<ReportResultType[]>([]);

  const contextValue = useMemo((): AsyncResultStateType => {
    const addReportResult = (data: Omit<ReportResultType, 'id'>) => {
      setReportResults((prevReportResults) => [...prevReportResults, { ...data, id: uuid() }]);
    };

    return {
      reportResults,
      addReportResult,
    };
  }, [reportResults]);

  return <AsyncResultContext.Provider value={contextValue}>{children}</AsyncResultContext.Provider>;
};

export const useAsyncResults = () => React.useContext(AsyncResultContext);
